import getWidgetSelectors from "./getWidgetSelectors"

export type ElementData = {
  integrationId: string | null
  stockId: string | null
  customData?: Record<string, string | number> | string
  carUrl: string | null
  departmentId: string | null
  hasExternalLogo: boolean | null
  sellerUrl?: string
}

type ParsedWidget = {
  elTarget: Element
  type: string
  leadFlowId?: number
  elData: ElementData
}

const parseCustomData = (
  json: string | null,
  selector: string
): ElementData["customData"] => {
  if (!json) return
  try {
    return JSON.parse(json)
  } catch (e) {
    console.error(`Error parsing custom data for ${selector}: ${json}`, e)
    return json
  }
}

const parseElementsForSelector = (
  selector: string,
  data?: { leadFlowId: number }
): ParsedWidget[] => {
  const elems = document.querySelectorAll(selector)
  const parsedData: ParsedWidget[] = []

  for (let i = 0, len = elems.length; i < len; i++) {
    const e = elems[i]

    if (!e) {
      continue
    }

    const customDataJson = e.getAttribute("data-custom-data")
    const customData = parseCustomData(customDataJson, selector)

    parsedData.push({
      elTarget: e,
      type: selector,
      leadFlowId: data?.leadFlowId,
      elData: {
        integrationId: e.getAttribute("data-integration-id"),
        stockId: e.getAttribute("data-stock-id"),
        customData,
        carUrl: e.getAttribute("data-car-url"),
        departmentId: e.getAttribute("data-department-id"),
        hasExternalLogo:
          e.nextElementSibling &&
          /au-trade-in-backlink/.test(e.nextElementSibling.className),
      },
    })
  }

  return parsedData
}

/**
 * Returns an array of widgets that should be shown on the dealer's website
 * based on found elements with specific class names
 */
export const parseWidgets = (
  customWidgetSelectors?: Record<string, string | undefined>,
  leadFlowButtonSelectors?: { lead_flow_id: number; json_value: string }[]
): ParsedWidget[] => {
  let widgets: ParsedWidget[] = []
  const widgetSelectors = getWidgetSelectors(customWidgetSelectors)
  Object.keys(widgetSelectors).forEach((widget) => {
    widgets = widgets.concat(
      parseElementsForSelector(
        widgetSelectors[widget as keyof typeof widgetSelectors]
      )
    )
  })
  leadFlowButtonSelectors?.forEach((s) => {
    widgets = widgets.concat(
      parseElementsForSelector(s.json_value, { leadFlowId: s.lead_flow_id })
    )
  })
  return widgets
}
